module.exports = __webpack_public_path__ + "8b465d5b75fd7a3bb4d20f1e1a2b01ae.pdf";